import { Flex, Tag } from 'antd';

const AccountInsights = ({
  title,
  cardColor,
  isBalanceVisible,
  AccountCurrency,
  TotalAmount,
}: {
  title: string;
  cardColor: string;
  isBalanceVisible: boolean;
  AccountCurrency: string;
  TotalAmount: string;
}) => {
  return (
    <Flex gap="small" vertical style={{ width: '100%' }}>
      <Tag color={cardColor} style={{ width: '100%' }}>
        <Flex vertical gap="middle" className="large-padding">
          <span className="medium-text">{title}</span>
          <Flex justify="space-between">
            <span className="medium-text">
              {isBalanceVisible ? TotalAmount : '*** *** ***'}
            </span>
            <span className="medium-text">
              {AccountCurrency || ''}
            </span>
          </Flex>
        </Flex>
      </Tag>
    </Flex>
  );
};

export default AccountInsights;
